import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CalendarMonthIcon(props: IconProps) {
    return <Icon {...props} iconKey={"calendar_month"}/>
}
